import { ObserverPositionDto } from './observer-position-dto';

export interface ObserverPhotoDto {
  photoId: string | null;
  deviceId: string | null;
  uploadedAtUtc: string | null;
  endTimeUtc: string | null;
  base64Data: string | null;
  contentType?: string | null;
  mimeType?: string | null;
  fileName?: string | null;
}

export interface ObserverPhotoViewModel {
  photoId: string;
  deviceId: string | null;
  uploadedAtUtc: string | null;
  endTimeUtc: string | null;
  base64Data: string;
  imageUrl: string;
  contentType: string;
  fileName: string | null;
}

export function normalizeObserverPhotoId(photoId: string | null | undefined): string | null {
  const normalizedPhotoId = photoId?.trim();

  return normalizedPhotoId ? normalizedPhotoId : null;
}

export function getObserverPhotoKey(observer: ObserverPositionDto): string {
  const deviceId = observer.deviceId?.trim();

  return deviceId ? `device:${deviceId}` : `observer:${observer.observerId}`;
}
